import React from 'react'
import AdminWithdrawals from '../../components/AdminWithdrawals/AdminWithdrawals'

export default function AdminWithdrawalsPage() {
  return (
    <AdminWithdrawals />
  )
}
